let appMode = process.env.REACT_APP_ENV;
let ASSET_URL = "https://pimpt-up.s3.eu-north-1.amazonaws.com/";
let URL;

console.log("appMode", appMode);

// 3.20.147.34

if (appMode === "development") {
  URL = "https://pimptup.com/api/";
} else {
  URL = "https://pimptup.com/api/";
  // URL = "http://localhost:8585/api/";
}

let apiPath = {
  baseURL: URL,
  assetURL: ASSET_URL,
  dashboard: "admin/dashboard/dashboard-data",

  listOrder: "admin/order/list",
  viewOrder: "admin/order/view",
  statusOrder: "admin/order/status",

  listTransaction: "admin/transaction/list",
  viewTransaction: "admin/transaction/view",

  // Auth API
  logout: "admin/auth/logout",
  login: "admin/auth/login",

  profile: "admin/auth/get-profile",
  updateProfile: "admin/auth/update-profile",
  changePassword: "admin/auth/change-password",
  updateAppSetting: "admin/auth/update-app-setting",
  updateSetting: "admin/auth/update-setting",

  forgotPassword: "admin/auth/forgot-password",
  verifyOTP: "admin/auth/verify-otp",
  resetPassword: "admin/auth/reset-password",

  // SubAdmin APIs
  listSubAdmin: "admin/sub-admin/list",
  addEditSubAdmin: "admin/sub-admin/add-edit",
  statusSubAdmin: "admin/sub-admin/status",
  viewSubAdmin: "admin/sub-admin/view",
  getModule: "admin/sub-admin/module-list",
  addPermission: "admin/sub-admin/add-permission",

  // Customer APIs
  listCustomer: "admin/customer/list",
  addEditCustomer: "admin/customer/add-edit",
  statusCustomer: "admin/customer/status",
  deleteCustomer: "admin/customer/delete",
  viewCustomer: "admin/customer/view",
  importCustomer: "admin/customer/import-file",

  // Dealer APIs
  listDealer: "admin/dealer/list",
  addEditDealer: "admin/dealer/add-edit",
  statusDealer: "admin/dealer/status",
  deleteDealer: "admin/dealer/delete",
  viewDealer: "admin/dealer/view",
  importDealer: "admin/dealer/import-file",

  // Specialist APIs
  listSpecialist: "admin/specialist/list",
  addEditSpecialist: "admin/specialist/add-edit",
  statusSpecialist: "admin/specialist/status",
  deleteSpecialist: "admin/specialist/delete",
  viewSpecialist: "admin/specialist/view",
  importSpecialist: "admin/specialist/import-file",

  // Quote APIs
  listQuote: "admin/quote/list",
  replyListQuote: "admin/quote/reply-list",
  addEditQuote: "admin/quote/add-edit",
  statusQuote: "admin/quote/status",
  viewQuote: "admin/quote/view",

  // Discount APIs
  listDiscount: "admin/discount/list",
  addEditDiscount: "admin/discount/add-edit",
  statusDiscount: "admin/discount/status",
  viewDiscount: "admin/discount/view",

  // Start Car Routes APIs
  listCarMake: "admin/car/make",
  addEditCarMake: "admin/car/add-edit-make",
  statusCarMake: "admin/car/status-make",
  importCarMake: "admin/car/import-make",

  listCarModel: "admin/car/model",
  addEditCarModel: "admin/car/add-edit-model",
  statusCarModel: "admin/car/status-model",
  importCarModel: "admin/car/import-model",

  listCarType: "admin/car/type",
  addEditCarType: "admin/car/add-edit-type",
  importCarType: "admin/car/import-type",
  statusCarType: "admin/car/status-type",

  listCarVariant: "admin/car/variant",
  addEditCarVariant: "admin/car/add-edit-variant",
  statusCarVariant: "admin/car/status-variant",
  importCarVariant: "admin/car/import-variant",

  // End Car Routes APIs

  listCategory: "admin/category/list",
  addEditCategory: "admin/category/add-edit",
  statusCategory: "admin/category/status",
  importCategory: "admin/category/import-file",

  // MakeModel APIs
  listCar: "admin/car/list",
  addEditCar: "admin/car/add-edit",
  statusCar: "admin/car/status",
  viewCar: "admin/car/view",

  // Service APIs
  listService: "admin/service/list",
  addEditService: "admin/service/add-edit",
  statusService: "admin/service/status",
  viewService: "admin/service/view",
  importService: "admin/service/import-file",

  // EmailTemplate APIs
  listEmailTemplate: "admin/email-template/list",
  addEditEmailTemplate: "admin/email-template/add-edit",
  statusEmailTemplate: "admin/email-template/status",
  viewEmailTemplate: "admin/email-template/view",

  // Blog APIs
  listBlog: "admin/blog/list",
  addEditBlog: "admin/blog/add-edit",
  statusBlog: "admin/blog/status",
  viewBlog: "admin/blog/view",

  // Banner APIs
  listBanner: "admin/banner/list",
  addEditBanner: "admin/banner/add-edit",
  statusBanner: "admin/banner/status",
  viewBanner: "admin/banner/view",

  // Banner APIs
  listBrand: "admin/brand/list",
  addEditBrand: "admin/brand/add-edit",
  statusBrand: "admin/brand/status",
  viewBrand: "admin/brand/view",
  importBrand: "admin/brand/import-file",

  // Content APIs
  listContent: "admin/content/list",
  addEditContent: "admin/content/add-edit",
  statusContent: "admin/content/status",
  viewContent: "admin/content/view",

  // Product APIs
  listProduct: "admin/product/list",
  addEditProduct: "admin/product/add-edit",
  statusProduct: "admin/product/status",
  viewProduct: "admin/product/view",
  editProduct: "admin/product/edit",
  importProduct: "admin/product/import-file",
  categoryAttribute: "admin/product/get-attribute",
  addAttribute: "admin/product/add-attribute",
  viewProductDealer: "admin/product/view-dealer",

  // Attribute APIs
  attribute: "admin/attribute",
  listAttribute: "admin/attribute/list",
  addEditAttribute: "admin/attribute/add-edit",
  statusAttribute: "admin/attribute/status",
  viewAttribute: "admin/attribute/view",
  editAttribute: "admin/attribute/edit",

  // Common Routes
  getSetting: "common/setting",
  carMakeList: "common/make",
  carModelList: "common/model",
  categoryList: "common/category",
  brandList: "common/brand",
  productList: "common/product",
  getAppSetting: "common/app-setting",
  activity: "common/user-activity",
  dealerSpecialist: "common/dealer-specialist",

  notification: "admin/notification",

  // Size APIs
  size: "admin/size",
};

export default apiPath;
